/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { OverlayDropinsView } from "./OverlayDropinsView";
import { inject } from "mobx-react";
import { getOverlayDropins } from "selectors/overlayDropinSelectors";
import { getIsPreviewMounted } from "selectors/appSelectors";

const mapStoreToProps = (stores, ownProps) => ({
  isPreviewMounted: getIsPreviewMounted(stores),
  overlayDropins: getOverlayDropins(stores).slice()
});
const OverlayDropinsContainer = inject(mapStoreToProps)(OverlayDropinsView);

export { OverlayDropinsContainer };
